import React from 'react';

interface SpinnerProps {
    containerHeight?: number;
}

const Spinner: React.FC<SpinnerProps> = ({ containerHeight }) => {
    return (
        <div className="loading" style={{ height: containerHeight || '100vh' }}>
            <svg className="spinner" viewBox="0 0 50 50">
                <circle
                    className="path"
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                    strokeWidth="5"
                ></circle>
            </svg>
        </div>
    );
};
export default Spinner;
